module.exports = __webpack_public_path__ + "e4f836279511093f5ce4f09da9163cc6.svg";